import type { ReactNode } from 'react';

import CoreDivider from '@ovpn/ui/divider';
import Text from '@ovpn/ui/text';

import { boxed } from '@sso/shared/hocs';

function Divider({ children, ...props }: { children?: ReactNode }) {
    return (
        <CoreDivider {...props}>
            {children && (
                <Text color="neutral.placeholder" size="textXs" weight="medium">
                    {children}
                </Text>
            )}
        </CoreDivider>
    );
}

export default boxed(Divider);
